import { createFeatureSelector } from '@ngrx/store';
import { ProfessionState } from './profession.entity';
import { professionReducer } from './profession.reducer';

export const PROFESSION_FEATURE_NAME: string = 'professiontypes';

export const selectProfessionState = createFeatureSelector<ProfessionState>(PROFESSION_FEATURE_NAME);


